import React from 'react';
import { mergeClassNames } from '../../../../utils';
import Button from '..';
import styles from './index.module.scss';

export function SecondaryButton({
  clickHandler,
  title = null,
  tabIndex = null,
  children = null,
  className = null,
  style = null,
  disabled = false,
  type = null,
  icon = null,
  appearance = appearances.default,
}) {
  return (
    <Button
      disabled={disabled}
      title={title}
      tabIndex={tabIndex}
      clickHandler={clickHandler}
      className={mergeClassNames([styles.button, className, styles[appearance], disabled ? styles.disabled : null])}
      style={style}
      startIcon={icon}
      type={type}
      buttonStyle={true}
    >
      {children}
    </Button>
  );
}

const appearances = {
  default: 'default',
  light: 'light',
};
